import React from "react";
import ReactPlayer from "react-player";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface VideoModalProps {
  url: string | null;
  title: string;
  onClose: () => void;
}

export default function VideoModal({ url, title, onClose }: VideoModalProps) {
  const playerRef = React.useRef<HTMLVideoElement>(null);
  return (
    <Dialog
      open={!!url}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            backgroundColor: "rgba(8, 7, 28, 0.75)",
          },
        },
      }}
      PaperProps={{
        sx: {
          background: "#13112E",
          border: "1px solid #211F45",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: `
            0 0 0 1px rgba(168, 126, 255, 0.25),
            0 8px 32px rgba(0, 0, 0, 0.6),
            0 32px 80px rgba(0, 0, 0, 0.5)
          `,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 16px",
          borderBottom: "1px solid #211F45",
        }}
      >
        <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: 600 }}>
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: "#6B6A8E", "&:hover": { color: "#fff" } }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "0 !important" }}>
        <Box sx={{ aspectRatio: "16 / 9", width: "100%", background: "#000" }}>
          <ReactPlayer
            src={url}
            width="100%"
            height="100%"
            playing
            controls
            onReady={() => playerRef.current?.play()}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
